module.exports = __webpack_public_path__ + "img/1920px-Roundel_of_the_Soviet_Union_(1945–1991).svg.f1ef4eac.png";